export const HOSTING_URL = 'https://hosting.glonasssoft.ru'
export const REGIONS_URL = 'https://regions.glonasssoft.ru'

export const WIALON_DEFAULT_URL = 'https://hst-api.wialon.com'
export const OMNICOMM_DEFAULT_URL = 'https://online.omnicomm.ru'
export const AXENTA_DEFAULT_URL = 'https://axenta.cloud'
export const GELIOS_DEFAULT_URL = 'https://admin.geliospro.com'
export const FORTMONITOR_DEFAULT_URL = 'https://fort-monitor.ru/'
export const GLONASSOFT_DEFAULT_URL = 'https://hosting.glonasssoft.ru'
